import React, { Component } from 'react';

import createHistory from 'history/createBrowserHistory'
import {
  Router,
  Route,
  Switch,
} from 'react-router-dom'

import './App.css';

import componentAsync from './app/components/component-async'

const StaticRecirectHome  = componentAsync(() => import('./app/pages/static/templates/static-redirect-home'))

const ShowPlay  = componentAsync(() => import('./app/pages/show/templates/show-play'))
const EpisodePlay  = componentAsync(() => import('./app/pages/episode/templates/episode-play'))
const EpisodePlaySimple  = componentAsync(() => import('./app/pages/episode/templates/episode-play-simple'))

const ShowPage  = componentAsync(() => import('./app/pages/show/templates/show-page'))
const EpisodePage  = componentAsync(() => import('./app/pages/episode/templates/episode-page'))

const history = createHistory();

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <div className="app">
          <main role="main" className="player-content">
            <Switch>
              // Embed
              <Route path="/embed/:frame_key/podcasts/:show_key" exact component={ShowPlay}/>
              <Route path="/embed/:frame_key/podcasts/:show_key/episodes/:episode_key" exact component={EpisodePlay}/>

              <Route path="/embed/simple/:frame_key/podcasts/:show_key/episodes/:episode_key" exact component={EpisodePlaySimple}/>

              // Page
              <Route path="/podcasts/:show_key" exact component={ShowPage}/>
              <Route path="/podcasts/:show_key/episodes/:episode_key" exact component={EpisodePage}/>

              <Route component={StaticRecirectHome}/>
            </Switch>
          </main>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js